/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/assets/js/custom-product-list.js ***!
  \**********************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// toggle on the top of the product list
function puMeaningfulBasketRoutes(toggle) {
  if (!toggle) return [];
  return Array.prototype.filter.call(toggle.querySelectorAll('.custom-product-list__toggle-item'), function (item) {
    return !item.hidden && item.getAttribute('hidden') === null && item.getAttribute('aria-hidden') !== 'true' && item.getAttribute('aria-disabled') !== 'true';
  });
}

// Shared: the basket button reads as unavailable, and says why, until the
// customer has chosen every option and a rent-or-buy route.
window.puRefreshBasketButton = function (btn) {
  if (!btn) return;
  var label = btn.querySelector('.app-product-page-item-title') || btn;
  if (!btn.dataset.readyLabel) btn.dataset.readyLabel = label.textContent.trim();
  var atc = btn.closest('atc-component');
  if (atc && !atc.dataset.readyLabel) atc.dataset.readyLabel = btn.dataset.readyLabel;
  var toggle = btn.closest('.custom-product-card__meta');
  var routes = puMeaningfulBasketRoutes(toggle).length;
  var text;
  if (btn.dataset.unavailable === 'true') text = 'Sold out';
  else if (btn.dataset.awaitingProperties === 'true') text = 'Choose a size first';
  else if (btn.dataset.awaitingOptions === 'true') text = 'Choose an option first';
  else if (btn.dataset.awaitingRoute === 'true') text = routes > 1 ? (atc && atc.dataset.routePrompt || 'Choose rent or buy') : btn.dataset.readyLabel;
  else {
    // Ready: say what the chosen route will do.
    var active = toggle ? toggle.querySelector('.custom-product-list__toggle-item.active') : null;
    var consult = /consultation|book/i.test(btn.dataset.readyLabel);
    var enquiry = active && active.dataset.enquiryRoute === 'true';
    if (enquiry) text = 'Talk to the team';
    // With a single route the page already labelled the button for this product,
    // so a one-month rental keeps its own label rather than being relabelled.
    else if (active && !consult && routes > 1) text = 'Checkout';
    else text = btn.dataset.readyLabel;
  }
  // Keep the route cards' checked state truthful for assistive technology.
  if (toggle) {
    toggle.querySelectorAll('.custom-product-list__toggle-item[role="radio"]').forEach(function (item) {
      item.setAttribute('aria-checked', item.classList.contains('active') ? 'true' : 'false');
    });
  }
  var gated = btn.dataset.submitting === 'true' || btn.dataset.unavailable === 'true' || btn.dataset.awaitingProperties === 'true' || btn.dataset.awaitingOptions === 'true' || btn.dataset.awaitingRoute === 'true';
  btn.disabled = gated;
  btn.classList.toggle('is-gated', btn.disabled);
  if (!btn.classList.contains('loading') && !btn.closest('atc-component.loading') && !btn.closest('atc-component.has-error') && !btn.closest('atc-component.has-success')) label.textContent = text;
};

var CustomProductListToggle = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomProductListToggle, _HTMLElement);
  var _super = _createSuper(CustomProductListToggle);
  function CustomProductListToggle() {
    var _this;
    _classCallCheck(this, CustomProductListToggle);
    _this = _super.call(this);
    _this.toggleButtons = _this.querySelectorAll('.custom-product-list__toggle-item');
    return _this;
  }
  _createClass(CustomProductListToggle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.toggleButtons = this.querySelectorAll('.custom-product-list__toggle-item');
      this.toggleButtons.forEach(function (button) {
        if (button.dataset.routeListenerReady === 'true') return;
        button.dataset.routeListenerReady = 'true';
        button.addEventListener('click', function () {
          _this2.toggleActiveClass(button);
        });
      });
    }
  }, {
    key: "toggleActiveClass",
    value: function toggleActiveClass(button) {
      if (!button || button.hidden || button.getAttribute('aria-disabled') === 'true') return;
      this.toggleButtons.forEach(function (button) {
        button.classList.remove('active');
      });
      button.classList.add('active');
      this.setPurchaseEnabled(true);
      var owner = this.closest('custom-product-card');
      var scope = this.closest('.shopify-section') || this;
      var cards = owner ? [owner] : scope.querySelectorAll('custom-product-card');
      cards.forEach(function (card) {
        if (typeof card.toggleSubscription === 'function') card.toggleSubscription(button.dataset.rent);
      });
    }
  }, {
    key: "setPurchaseEnabled",
    value: function setPurchaseEnabled(enabled) {
      var meta = this.closest('.custom-product-card__meta');
      if (!meta) return;
      meta.querySelectorAll('atc-component button').forEach(function (btn) {
        if (enabled) delete btn.dataset.awaitingRoute;
        else btn.dataset.awaitingRoute = 'true';
        // The variant picker gates on its own flags. Recompute from all of
        // them so neither side can re-enable over the other.
        window.puRefreshBasketButton(btn);
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this3 = this;
      this.setEventListeners();
      var routeChoices = puMeaningfulBasketRoutes(this);
      // A single route is not a customer decision. Select it immediately so
      // the basket action is ready, while independent size/variant gates stay
      // authoritative. Avoid click() here because that also toggles rent-mode.
      if (routeChoices.length === 1) {
        this.toggleButtons.forEach(function (item) {
          item.classList.remove('active');
          if (item.getAttribute('role') === 'radio') item.setAttribute('aria-checked', 'false');
        });
        routeChoices[0].classList.add('active');
        if (routeChoices[0].getAttribute('role') === 'radio') routeChoices[0].setAttribute('aria-checked', 'true');
        this.setPurchaseEnabled(true);
        return;
      }
      // With two or more routes, nothing is pre-selected: the customer has to
      // pick rent or buy before the basket button wakes up.
      // Services such as the consultation opt back in with data-auto-select.
      if (_this3.dataset.autoSelect !== 'true') {
        _this3.querySelectorAll('.custom-product-list__toggle-item').forEach(function (item) { item.classList.remove('active'); if (item.getAttribute('role') === 'radio') item.setAttribute('aria-checked', 'false'); });
        _this3.setPurchaseEnabled(false);
        return;
      }
      setTimeout(function () {
        var defaultToggle = _this3.querySelector('[data-rent="rent"]') || _this3.querySelector('.custom-product-list__toggle-item');
        if (defaultToggle) defaultToggle.click();
      }, 200);
    }
  }]);
  return CustomProductListToggle;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-list-toggle')) {
  customElements.define('custom-product-list-toggle', CustomProductListToggle);
}

// product card, mostly used to store data and trigger modal open
var CustomProductCard = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(CustomProductCard, _HTMLElement2);
  var _super2 = _createSuper(CustomProductCard);
  function CustomProductCard() {
    var _this4;
    _classCallCheck(this, CustomProductCard);
    _this4 = _super2.call(this);
    _this4.triggerButtons = _this4.querySelectorAll('.custom-product-card--trigger');
    _this4.targetPopupId = _this4.dataset.targetpopup;
    _this4.targetPopup = document.querySelector("[data-popupid=\"".concat(_this4.targetPopupId, "\"]"));
    _this4.product = _this4.dataset.product;
    _this4.originalPrice = _this4.dataset.price;
    _this4.mode = 'Buy';
    _this4.parentSection = _this4.closest('.shopify-section');
    _this4.priceElm = _this4.querySelector('.custom-product-card__meta-price span');
    return _this4;
  }
  _createClass(CustomProductCard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "toggleSubscription",
    value: function toggleSubscription(route) {
      this.mode = route === 'rent' ? 'Rent' : 'Buy';
      this.parentSection = this.closest('.shopify-section');
      if (this.parentSection) this.parentSection.classList.toggle('rent-mode', this.mode === 'Rent');
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this5 = this;
      this.triggerButtons = this.querySelectorAll('.custom-product-card--trigger');
      this.triggerButtons.forEach(function (button) {
        button.onclick = function (event) {
          // Sections may arrive after the card or replace the original popup.
          // Resolve at activation time and keep the product page as a fallback.
          var targetId = _this5.dataset.targetpopup;
          var popup = Array.prototype.find.call(document.querySelectorAll('[data-popupid]'), function (item) {
            return item.dataset.popupid === targetId;
          });
          var productUrl = _this5.dataset.product;
          if (popup && typeof popup.openModal === 'function') {
            event.preventDefault();
            popup.openModal(productUrl);
          } else if (productUrl && !button.closest('a[href]')) {
            event.preventDefault();
            window.location.assign(productUrl);
          }
        };
      });
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return CustomProductCard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-card')) {
  customElements.define('custom-product-card', CustomProductCard);
}
var CustomProductTabs = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(CustomProductTabs, _HTMLElement3);
  var _super3 = _createSuper(CustomProductTabs);
  function CustomProductTabs() {
    var _this6;
    _classCallCheck(this, CustomProductTabs);
    _this6 = _super3.call(this);
    _this6.tabButtons = _this6.querySelectorAll('.custom-product-tabs__tab-button');
    _this6.tabs = _this6.querySelectorAll('.custom-product-tabs__tab-content');
    _this6.activeButtonClass = 'custom-product-tabs__tab-button--active';
    _this6.activeTabClass = 'custom-product-tabs__tab-content--active';
    return _this6;
  }
  _createClass(CustomProductTabs, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this7 = this;
      this.tabButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          _this7.toggleActiveTab(index);
        });
      });
    }
  }, {
    key: "toggleActiveTab",
    value: function toggleActiveTab(index) {
      var _this8 = this;
      this.tabButtons.forEach(function (button) {
        button.classList.remove(_this8.activeButtonClass);
      });
      this.tabs.forEach(function (tab) {
        tab.classList.remove(_this8.activeTabClass);
      });
      this.tabButtons[index].classList.add(this.activeButtonClass);
      this.tabs[index].classList.add(this.activeTabClass);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return CustomProductTabs;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-tabs-desktop')) {
  customElements.define('custom-product-tabs-desktop', CustomProductTabs);
}

// to do: atc-component

// modal popup
var CustomProductPopup = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(CustomProductPopup, _HTMLElement4);
  var _super4 = _createSuper(CustomProductPopup);
  function CustomProductPopup() {
    var _this9;
    _classCallCheck(this, CustomProductPopup);
    _this9 = _super4.call(this);
    _this9.overlay = _this9.querySelector('.custom-product-popup__overlay');
    _this9.closeButton = _this9.querySelector('.custom-product-popup__icon-close');
    _this9.contentWrapper = _this9.querySelector('.custom-product-popup-wrapper__content');
    _this9.body = document.body;
    return _this9;
  }
  _createClass(CustomProductPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this10 = this;
      this.closeButton.addEventListener('click', function () {
        _this10.closeModal();
      });
      this.overlay.addEventListener('click', function () {
        _this10.closeModal();
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.style.display = 'none';
      this.overlay.style.display = 'none';
      this.body.style.overflow = 'auto';
    }
  }, {
    key: "openModal",
    value: function openModal(product) {
      this.style.display = 'flex';
      this.overlay.style.display = 'block';
      this.body.style.overflow = 'hidden';
      if (product) {
        this.pullProduct(product);
      }
    }
  }, {
    key: "pullProduct",
    value: function pullProduct(productUrl) {
      var _this11 = this;
      // Add loading class to the whole popup
      this.classList.add('loading');

      // Perform the fetch request
      fetch("".concat(productUrl, "?view=ajax")).then(function (response) {
        return response.text();
      }).then(function (htmlString) {
        // Create a temporary container to hold the response HTML
        var tempContainer = document.createElement('div');
        tempContainer.innerHTML = htmlString;

        // Extract content from .custom-product-popup-wrapper__content
        var content = tempContainer.querySelector('.custom-product-popup-wrapper__content');
        if (content) {
          // Update the contentWrapper innerHTML
          _this11.contentWrapper.innerHTML = content.innerHTML;
          if (_this11.querySelector('.swiper')) {
            _this11.startSwiper();
          }
        }

        // Remove loading class after content is loaded
        _this11.classList.remove('loading');
      })["catch"](function (error) {
        console.error('Error fetching product:', error);
        // Remove loading class in case of an error
        _this11.classList.remove('loading');
      });
    }
  }, {
    key: "startSwiper",
    value: function startSwiper() {
      var _this12 = this;
      this.slider = this.querySelector('.swiper');
      this.nextArrow = this.querySelector('.swiper-button-next');
      this.prevArrow = this.querySelector('.swiper-button-prev');
      var main_options = {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: this.nextArrow,
          prevEl: this.prevArrow
        }
      };
      var initSwiper = function initSwiper() {
        if (!_this12.slider) {
          return true;
        }
        if (typeof Swiper === 'undefined') {
          return false;
        }
        _this12.activeSlider = new Swiper(_this12.slider, main_options);
        return true;
      };
      var swiperCheckInterval = setInterval(function () {
        if (initSwiper()) {
          clearInterval(swiperCheckInterval);
        }
      }, 100);
    }
  }, {
    key: "toggleActiveClass",
    value: function toggleActiveClass(button) {
      this.toggleButtons.forEach(function (button) {
        button.classList.remove('active');
      });
      button.classList.add('active');
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setEventListeners();
    }
  }]);
  return CustomProductPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-product-popup')) {
  customElements.define('custom-product-popup', CustomProductPopup);
}

// atc wrapper
var AtcComponent = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(AtcComponent, _HTMLElement5);
  var _super5 = _createSuper(AtcComponent);
  function AtcComponent() {
    var _this13;
    _classCallCheck(this, AtcComponent);
    _this13 = _super5.call(this);
    _this13.variant = _this13.dataset.variant;
    _this13.plans = JSON.parse(_this13.dataset.plans);
    _this13.parentSection = _this13.closest('.shopify-section');
    _this13.button = _this13.querySelector('button');
    _this13.initialText = _this13.textContent;
    _this13.initialMarkup = _this13.button ? _this13.button.innerHTML : '';
    _this13.loadingText = _this13.dataset.loading;
    _this13.successText = _this13.dataset.success;
    _this13.isSubmitting = false;
    return _this13;
  }
  _createClass(AtcComponent, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this14 = this;
      if (!this.button) return;
      this.button.addEventListener('click', function () {
        _this14.addToCart();
      });
    }
  }, {
    key: "ensureStatusRegions",
    value: function ensureStatusRegions() {
      this.statusRegion = this.querySelector('[data-atc-status]');
      if (!this.statusRegion) {
        this.statusRegion = document.createElement('span');
        this.statusRegion.className = 'visually-hidden';
        this.statusRegion.dataset.atcStatus = '';
        this.statusRegion.setAttribute('role', 'status');
        this.statusRegion.setAttribute('aria-live', 'polite');
        this.statusRegion.setAttribute('aria-atomic', 'true');
        this.appendChild(this.statusRegion);
      }
      this.errorRegion = this.querySelector('[data-atc-error]');
      if (!this.errorRegion) {
        this.errorRegion = document.createElement('span');
        this.errorRegion.className = 'visually-hidden';
        this.errorRegion.dataset.atcError = '';
        this.errorRegion.setAttribute('role', 'alert');
        this.errorRegion.setAttribute('aria-atomic', 'true');
        this.appendChild(this.errorRegion);
      }
    }
  }, {
    key: "setSubmitting",
    value: function setSubmitting(submitting) {
      this.isSubmitting = submitting;
      this.classList.toggle('loading', submitting);
      if (submitting) this.setAttribute('aria-busy', 'true');
      else this.removeAttribute('aria-busy');
      if (!this.button) return;
      if (submitting) {
        this.button.dataset.submitting = 'true';
        this.button.setAttribute('aria-busy', 'true');
      } else {
        delete this.button.dataset.submitting;
        this.button.removeAttribute('aria-busy');
      }
      if (window.puRefreshBasketButton) {
        window.puRefreshBasketButton(this.button);
      } else {
        this.button.disabled = this.button.dataset.submitting === 'true'
          || this.button.dataset.unavailable === 'true'
          || this.button.dataset.awaitingProperties === 'true'
          || this.button.dataset.awaitingOptions === 'true'
          || this.button.dataset.awaitingRoute === 'true';
      }
    }
  }, {
    key: "restoreButton",
    value: function restoreButton() {
      if (this.button) this.button.innerHTML = this.initialMarkup;
    }
  }, {
    key: "scheduleButtonRestore",
    value: function scheduleButtonRestore(delay) {
      var _this15 = this;
      clearTimeout(this.successTimer);
      this.successTimer = setTimeout(function () {
        _this15.classList.remove('has-success');
        _this15.restoreButton();
        if (_this15.statusRegion) _this15.statusRegion.textContent = '';
        if (window.puRefreshBasketButton) window.puRefreshBasketButton(_this15.button);
      }, delay);
    }
  }, {
    key: "addToCart",
    value: function addToCart() {
      
      var _this15 = this;
      // Set synchronously before fetch so rapid pointer, keyboard or touch
      // activation cannot submit the same purchase twice.
      if (this.isSubmitting || !this.button || this.button.disabled) return;
      var meta = this.closest('.custom-product-card__meta');
      var activeRoute = meta ? meta.querySelector('.custom-product-list__toggle-item.active') : null;
      if (!activeRoute) return;
      var toggle_info = activeRoute.dataset.rent;

      // The variant picker rewrites data-variant whenever an option changes,
      // so read it at click time rather than trusting the value cached when
      // the element was constructed. With no variant there is nothing to add.
      // Where the shown price is a starting price, the route opens a conversation
      // rather than a basket, because the final figure depends on the model chosen.
      if (activeRoute.dataset.enquiryRoute === 'true') {
        var enquiryTrigger = document.querySelector('[data-email-open]');
        if (enquiryTrigger) enquiryTrigger.click();
        else window.location.href = window.OxydiseCallTracking?.getHref() || 'tel:+441223657444';
        return;
      }

      var variantId = this.dataset.variant || this.variant;
      if (!variantId) {
        this.showError('Choose an option first');
        return;
      }

      var sellingPlan = null;
      if (toggle_info == 'rent') {
        var sellingPlanGroup = this.plans[0];
        sellingPlan = sellingPlanGroup && sellingPlanGroup.selling_plans && sellingPlanGroup.selling_plans[0];
        if (!sellingPlan) {
          this.showError(this.dataset.planUnavailable || 'This rental option is unavailable. Please choose another option or try again.');
          return;
        }
      }

      this.ensureStatusRegions();
      clearTimeout(this.errorTimer);
      clearTimeout(this.successTimer);
      this.classList.remove('has-error', 'has-success');
      this.statusRegion.textContent = '';
      this.errorRegion.textContent = '';
      this.setSubmitting(true);
      this.button.textContent = this.loadingText;
      this.statusRegion.textContent = this.loadingText;
      var data = {
        "id": variantId,
        "quantity": 1
      };
      if (toggle_info == 'rent') {
        var selling_plan_id = sellingPlan.id;
        var frequency = sellingPlan.options && sellingPlan.options[0] ? sellingPlan.options[0].value : '1';
        data['selling_plan'] = selling_plan_id;
        data['properties'] = {
          "_shipping_interval_frequency": frequency,
          "_shipping_interval_unit_type": 'Month'
        };
      }

      // Required configuration that is not represented by a Shopify variant
      // still has to travel with the physical product. Read the selected,
      // explicitly named property at click time so the basket, checkout and
      // fulfilment record all carry the same chamber size the customer chose.
      var propertyRoot = this.closest('.custom-product-card');
      if (propertyRoot) {
        propertyRoot.querySelectorAll('[data-line-item-property]:checked').forEach(function (field) {
          var propertyName = field.dataset.lineItemPropertyName;
          if (!propertyName || !field.value) return;
          data.properties = data.properties || {};
          data.properties[propertyName] = field.value;
        });
      }

      // There is no basket: Checkout buys this one product. Clear anything left
      // from an earlier visit, add this product, then go straight to checkout.
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function () {
        // cartDrawerHandled tells cart.js's fetch wrapper not to refresh and open
        // the basket drawer after this add: the page is leaving for checkout, and
        // the drawer would otherwise slide in still saying the basket is empty.
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
          cartDrawerHandled: true
        });
      }).then(function (response) {
        return response.json().then(function (payload) {
          return { ok: response.ok, status: response.status, payload: payload };
        });
      }).then(function (result) {
        // Shopify answers 422 with JSON, so a failed add used to read as
        // success. Surface the message instead and stay on the page.
        if (!result.ok) {
          var message = result.payload && (result.payload.description || result.payload.message) || 'Could not open checkout';
          console.error('Checkout add failed', result.status, result.payload);
          _this15.showError(message);
          return;
        }
        _this15.button.textContent = _this15.successText;
        _this15.statusRegion.textContent = _this15.successText;
        _this15.classList.add('has-success');
        _this15.leavingForCheckout = true;
        // Coming back from checkout restores this page from the browser cache
        // with the button still busy, so reset it when the page is shown again.
        window.addEventListener('pageshow', function () {
          _this15.leavingForCheckout = false;
          _this15.classList.remove('has-success');
          _this15.restoreButton();
          if (_this15.statusRegion) _this15.statusRegion.textContent = '';
          _this15.setSubmitting(false);
        }, { once: true });
        window.location.assign('/checkout');
      })["catch"](function (error) {
        console.error('Checkout failed:', error);
        _this15.showError('Could not open checkout. Please call us.');
      })["finally"](function () {
        // Recompute every gate rather than blindly enabling the button, so
        // route, size, option and availability locks remain authoritative.
        // While checkout is loading the button stays busy.
        if (!_this15.leavingForCheckout) _this15.setSubmitting(false);
      });
    }
  }, {
    key: "showError",
    value: function showError(message) {
      var _this16 = this;
      this.ensureStatusRegions();
      clearTimeout(this.successTimer);
      this.classList.remove('has-success');
      this.classList.add('has-error');
      this.statusRegion.textContent = '';
      this.errorRegion.textContent = message;
      this.button.textContent = message;
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(function () {
        _this16.classList.remove('has-error');
        _this16.restoreButton();
        if (_this16.errorRegion) _this16.errorRegion.textContent = '';
        if (window.puRefreshBasketButton) window.puRefreshBasketButton(_this16.button);
      }, 3500);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.ensureStatusRegions();
      this.setEventListeners();
    }
  }]);
  return AtcComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('atc-component')) {
  customElements.define('atc-component', AtcComponent);
}
/******/ })()
;
